import {
  INSERT_CUPOM_DESCONTO,
  INSERT_CUPOM_DESCONTOLOADING,

  VALIDAR_CUPOM_PASSWORD,
  VALIDAR_CUPOM_PASSWORDLOADING,

  CUPOM_GERENCIADOR_LIST,
  CUPOM_GERENCIADOR_LISTLOADING,
  CUPOM_GERENCIADOR_LISTERROR,

  CUPOM_GERENCIADOR_VENDEDOR_LIST,
  CUPOM_GERENCIADOR_VENDEDOR_LISTLOADING

} from '../actions/ActionsTypes';

import * as Api from '../utils/API';

function uniqueByCodParc(lista) {
  const vistos = new Set();

  return lista.filter((item) => {
    const codparc = item?.codparc;

    if (codparc === null || codparc === undefined) {
      return true;
    }

    if (vistos.has(codparc)) {
      return false;
    }

    vistos.add(codparc);
    return true;
  });
}

export const InsertCupomDescontoAction = (codparc, nomeparc, entidade) => (dispatch) =>
  new Promise(function (resolve, reject) {
    dispatch({ type: INSERT_CUPOM_DESCONTOLOADING, payload: true })
    Api.inserirCupomDesconto(codparc, nomeparc, entidade).then(dados => {
      dispatch({ type: INSERT_CUPOM_DESCONTO, payload: dados })
      dispatch({ type: INSERT_CUPOM_DESCONTOLOADING, payload: false })
      resolve(dados)
    }).catch(error => {
      dispatch({ type: INSERT_CUPOM_DESCONTOLOADING, payload: false })
      reject(error);
    })
  });

export const ValidarSenhaAction = (codparc, password) => (dispatch) =>
  new Promise(function (resolve, reject) {
    dispatch({ type: VALIDAR_CUPOM_PASSWORDLOADING, payload: true })
    Api.validarSenhaCupom(codparc, password).then(dados => {
      dispatch({ type: VALIDAR_CUPOM_PASSWORD, payload: dados })
      dispatch({ type: VALIDAR_CUPOM_PASSWORDLOADING, payload: false })
      resolve(dados)
    }).catch(error => {
      reject(error);
    });
  });

export const CupomGerenciadorListAction = (entidade) => (dispatch) =>
  new Promise(function (resolve, reject) {
    const status = String(entidade?.status || 'ATIVO').toUpperCase();
    dispatch({ type: CUPOM_GERENCIADOR_LISTLOADING, payload: { status, loading: true } })
    dispatch({ type: CUPOM_GERENCIADOR_LISTERROR, payload: { status, erro: '' } })

    Api.listarCuponsGerenciador(entidade).then(dados => {
      const lista = uniqueByCodParc(Array.isArray(dados) ? dados : []);
      dispatch({ type: CUPOM_GERENCIADOR_LIST, payload: { status, lista } })
      dispatch({ type: CUPOM_GERENCIADOR_LISTLOADING, payload: { status, loading: false } })
      resolve(lista)
    }).catch(error => {
      dispatch({ type: CUPOM_GERENCIADOR_LIST, payload: { status, lista: [] } })
      dispatch({ type: CUPOM_GERENCIADOR_LISTERROR, payload: { status, erro: 'Nao foi possivel carregar os cupons.' } })
      dispatch({ type: CUPOM_GERENCIADOR_LISTLOADING, payload: { status, loading: false } })
      reject(error);
    })
  });

export const CupomGerenciadorVendedoresListAction = (userid) => (dispatch) =>
  new Promise(function (resolve, reject) {
    dispatch({ type: CUPOM_GERENCIADOR_VENDEDOR_LISTLOADING, payload: true })

    Api.getVendedorLista(userid).then(dados => {
      const lista = Array.isArray(dados) ? dados : [];
      dispatch({ type: CUPOM_GERENCIADOR_VENDEDOR_LIST, payload: lista })
      dispatch({ type: CUPOM_GERENCIADOR_VENDEDOR_LISTLOADING, payload: false })
      resolve(lista)
    }).catch(error => {
      dispatch({ type: CUPOM_GERENCIADOR_VENDEDOR_LIST, payload: [] })
      dispatch({ type: CUPOM_GERENCIADOR_VENDEDOR_LISTLOADING, payload: false })
      reject(error);
    })
  });

